import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FilledInput } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';

import type { EditInputCellParams } from '../DetailsSectionTableInputCells';

function CurrencyEditInputCell(props: EditInputCellParams) {
	const apiRef = useGridApiContext();

	const inputRef = React.useRef<HTMLInputElement>(undefined);

	const handleChange: React.ChangeEventHandler<HTMLInputElement> = async event => {
		const newNumberValue = Number.parseFloat(event.target.value?.replaceAll('.', '').replace(',', '.'));
		const newValue = newNumberValue || newNumberValue === 0 ? newNumberValue : null;
		await apiRef.current.setEditCellValue({ id: props.id, field: props.field, value: newValue, debounceMs: 200 });
	};

	const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = async event => {
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
		}
	};

	React.useEffect(() => {
		if (props.hasFocus) inputRef.current?.focus();
	}, [props.hasFocus]);

	return (
		<NumericFormat
			className={props.className}
			classes={{ root: 'h-full w-full rounded-none p-8 tabular-nums', input: 'p-4 text-right' }}
			inputRef={inputRef}
			customInput={FilledInput}
			value={props.value ?? ''}
			endAdornment="€"
			onChange={handleChange}
			onKeyDown={handleKeyDown}
			thousandSeparator="."
			decimalSeparator=","
			decimalScale={2}
			fixedDecimalScale
			disableUnderline
		/>
	);
}

export default React.memo(CurrencyEditInputCell);
